import type { ResetPasswordRequest } from '../api'
import type { LoginAccount } from '../api'
import type { LookupParticipantRequest } from '../api'
import type { StoreAccountRequest } from '../api'
import type { TournamentTeamParticipantRegistration } from '../api'
import type { TournamentTeamJerseyColors } from '../api'
import type { ParticipantProfile } from '../api'

// Auto-generated default objects

export const DEFAULT_RESETPASSWORDREQUEST: ResetPasswordRequest = {
  token: '',
  email: '',
  password: '',
  password_confirmation: ''
}

export const DEFAULT_LOGINACCOUNT: LoginAccount = {
  email: '',
  password: ''
}

export const DEFAULT_LOOKUPPARTICIPANTREQUEST: LookupParticipantRequest = {
  participant_number: undefined,
  email: '',
  last_name: '',
  first_name: '',
  date_of_birth: '',
  club_name: '',
  last_season_of_registration: undefined
}

export const DEFAULT_STOREACCOUNTREQUEST: StoreAccountRequest = {
  first_name: '',
  last_name: '',
  email: '',
  password: '',
  password_confirmation: '',
  current_password: ''
}

export const DEFAULT_TOURNAMENTTEAMPARTICIPANTREGISTRATION: TournamentTeamParticipantRegistration =
  {
    participant_number: 0,
    last_name: '',
    first_name: '',
    date_of_birth: '',
    club_id: 0,
    role_id: 0,
    exception: false
  }

export const DEFAULT_TOURNAMENTTEAMJERSEYCOLORS: TournamentTeamJerseyColors = {
  jersey_color: '',
  shorts_color: '',
  sock_color_light: '',
  sock_color_dark: '',
  gk_jersey_color: ''
}

export const DEFAULT_PARTICIPANTPROFILE: ParticipantProfile = {}
